module.exports = __webpack_public_path__ + "static/media/login_bg.990bef61.png";